import * as z from "zod";

const COUNTRIES_REQUIRING_STATE = new Set(["CA", "US", "MX"]);

export const addressSchema = z
  .preprocess(
    (val) => (val && typeof val === "object" ? val : {}),
    z.object({
      countryCode: z.preprocess(
        (v) => v ?? "",
        z.string({ error: () => "form:error.required" })
        .trim()
        .min(1, { message: "form:error.required" })
      ),
      streetNumber: z
        .string({ error: () => "form:error.required" })
        .trim()
        .min(1, { message: "form:error.required" }),
      street: z
        .string({ error: () => "form:error.required" })
        .trim()
        .min(1, { message: "form:error.required" }),
      unit: z
        .string()
        .trim()
        .nullish()
        .transform((s) => s ?? ""),
      city: z
        .string({ error: () => "form:error.required" })
        .trim()
        .min(1, { message: "form:error.required" }),
      stateCode: z
        .string()
        .trim()
        .nullish()
        .transform((s) => s ?? ""),
      postalCode: z
        .string({ error: () => "form:error.required" })
        .trim()
        .min(1, { message: "form:error.required" })
        .max(10, { message: "form:error.tooLong" }),
    })
  )
  .superRefine((values, ctx) => {
    const needsState = !values.countryCode || COUNTRIES_REQUIRING_STATE.has(values.countryCode);
    if (needsState && !values.stateCode) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: "form:error.required",
        path: ["stateCode"],
      });
    }
  })
  .superRefine((values, ctx) => {
    if (values.countryCode === "US") {
      const isOk = z
        .string()
        .trim()
        .regex(/(^\d{5}$)|(^\d{5}-\d{4}$)/, "form:error.invalid")
        .safeParse(values.postalCode);

      if (!isOk.success) {
        isOk.error.issues.forEach((issue) => {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: issue.message,
            path: [...issue.path, "postalCode"],
          });
        });
      }

      return;
    }

    if (values.countryCode === "CA") {
      const isOk = z
        .string()
        .trim()
        .toUpperCase()
        .regex(
          /^[ABCEGHJ-NPRSTVXY][0-9][ABCEGHJ-NPRSTV-Z] ?[0-9][ABCEGHJ-NPRSTV-Z][0-9]$/i,
          "form:error.invalid"
        )
        .safeParse(values.postalCode);

      if (!isOk.success) {
        isOk.error.issues.forEach((issue) => {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: issue.message,
            path: [...issue.path, "postalCode"],
          });
        });
      }
    }
  });
